
export const trackWhatsAppClick = (buttonText: string, whatsappUrl: string, buttonLocation: string) => {
  if (typeof window !== 'undefined' && (window as any).dataLayer) {
    (window as any).dataLayer.push({
      event: "whatsapp_click",
      button_text: buttonText,
      page_path: window.location.pathname,
      whatsapp_url: whatsappUrl,
      button_location: buttonLocation
    });
  }
};
